"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _ShareButton = _interopRequireDefault(require("../decorators/ShareButton"));

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _wrapPropTypes = require("../utils/propTypes/wrapPropTypes");

var _UIButton = _interopRequireDefault(require("./UIButton"));

var UICopyButton = function UICopyButton(props) {
  var buttonRef = props.buttonRef,
      children = props.children,
      hint = props.hint,
      hintSuccess = props.hintSuccess,
      onClick = props.onClick,
      tooltipClassName = props.tooltipClassName,
      tooltipPlacement = props.tooltipPlacement,
      value = props.value,
      valueWhenCopied = props.valueWhenCopied,
      rest = (0, _objectWithoutProperties2.default)(props, ["buttonRef", "children", "hint", "hintSuccess", "onClick", "tooltipClassName", "tooltipPlacement", "value", "valueWhenCopied"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      tooltipActive = _useState2[0],
      setTooltipActive = _useState2[1];

  var handleTooltipOpenChange = function handleTooltipOpenChange(evt) {
    // Every time the tooltip opens, reset to the original title
    if (evt.target.value) {
      if (tooltipActive) setTooltipActive(false);
    }
  };

  var handleClick = function handleClick(evt) {
    var textarea = document.createElement('textarea');
    var parentEl = buttonRef.current.parentElement;
    parentEl.appendChild(textarea);
    textarea.value = valueWhenCopied(value);
    textarea.select();
    textarea.setSelectionRange(0, 999999); // Needed for iOS Safari

    try {
      document.execCommand('copy');
      setTooltipActive(true);
    } catch (err) {
      /* Ignore error */
    }

    parentEl.removeChild(textarea); // Restore focus to the button element

    buttonRef.current.focus();
    if (onClick) onClick(evt);
  };

  var tooltipTitle = tooltipActive ? (0, _lazyEval.default)(hintSuccess) : (0, _lazyEval.default)(hint);

  var renderedButtonContent = children || _react.default.createElement("span", {
    className: "private-button--internal-spacing"
  }, _I18n.default.text('salesUI.UICopyInput.label'));

  return _react.default.createElement(_UITooltip.default, {
    className: tooltipClassName,
    disabled: !tooltipTitle,
    onOpenChange: handleTooltipOpenChange,
    placement: tooltipPlacement,
    title: tooltipTitle
  }, _react.default.createElement(_UIButton.default, Object.assign({}, rest, {
    buttonRef: buttonRef,
    onClick: handleClick
  }), renderedButtonContent));
};

UICopyButton.propTypes = Object.assign({}, (0, _wrapPropTypes.wrapPropTypes)(_UIButton.default), {
  buttonRef: _refObject.default.isRequired,
  children: _propTypes.default.node,
  hint: (0, _createLazyPropType.default)(_propTypes.default.node).isRequired,
  hintSuccess: (0, _createLazyPropType.default)(_propTypes.default.node).isRequired,
  onClick: _propTypes.default.func,
  tooltipClassName: _propTypes.default.string,
  tooltipPlacement: _UITooltip.default.propTypes.placement,
  value: _propTypes.default.any,
  valueWhenCopied: _propTypes.default.func
});
UICopyButton.defaultProps = {
  hint: function hint() {
    return _I18n.default.text('salesUI.UICopyInput.title');
  },
  hintSuccess: function hintSuccess() {
    return _I18n.default.text('salesUI.UICopyInput.tooltipCopied');
  },
  tooltipPlacement: 'top',
  use: 'tertiary-light',
  valueWhenCopied: function valueWhenCopied(value) {
    return value;
  }
};
UICopyButton.displayName = 'UICopyButton';

var _default = (0, _ShareButton.default)(UICopyButton);

exports.default = _default;
module.exports = exports.default;